"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _fontawesomeSvgCore = require("@fortawesome/fontawesome-svg-core");

var _proSolidSvgIcons = require("@fortawesome/pro-solid-svg-icons");

var _proRegularSvgIcons = require("@fortawesome/pro-regular-svg-icons");

var _icon = require("./icon.styles");

var _text = require("../../../styles/2_commonComponentStyles/text");

var _iconNames = _interopRequireDefault(require("../../../constants/iconNames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var regularIcons = ['archive', 'building', 'calendar', 'circle', 'eye', 'eye-slash', 'external-link-square', 'mailbox', 'square'];

_fontawesomeSvgCore.library.add( // solid icons
_proSolidSvgIcons.faAmbulance, _proSolidSvgIcons.faAward, _proSolidSvgIcons.faArrowDown, _proSolidSvgIcons.faArrowLeft, _proSolidSvgIcons.faArrowRight, _proSolidSvgIcons.faArrowUp, _proSolidSvgIcons.faBars, _proSolidSvgIcons.faCaretDown, _proSolidSvgIcons.faCheck, _proSolidSvgIcons.faCheckCircle, _proSolidSvgIcons.faCheckSquare, _proSolidSvgIcons.faChevronDown, _proSolidSvgIcons.faChevronLeft, _proSolidSvgIcons.faChevronRight, _proSolidSvgIcons.faChevronUp, _proSolidSvgIcons.faCommentAlt, _proSolidSvgIcons.faCreditCard, _proSolidSvgIcons.faDollarSign, _proSolidSvgIcons.faDotCircle, _proSolidSvgIcons.faDownload, _proSolidSvgIcons.faEnvelope, _proSolidSvgIcons.faEllipsisH, _proSolidSvgIcons.faEllipsisV, _proSolidSvgIcons.faExclamationCircle, _proSolidSvgIcons.faExclamationTriangle, _proSolidSvgIcons.faFile, _proSolidSvgIcons.faFilter, _proSolidSvgIcons.faHashtag, _proSolidSvgIcons.faHistory, _proSolidSvgIcons.faInfoCircle, _proSolidSvgIcons.faLock, _proRegularSvgIcons.faMailbox, _proSolidSvgIcons.faMapMarkerAlt, _proSolidSvgIcons.faMapMarkerTimes, _proSolidSvgIcons.faMinus, _proSolidSvgIcons.faMinusCircle, _proSolidSvgIcons.faPencilAlt, _proSolidSvgIcons.faPercent, _proSolidSvgIcons.faPhone, _proSolidSvgIcons.faPlus, _proSolidSvgIcons.faPlusCircle, _proSolidSvgIcons.faSearch, _proSolidSvgIcons.faSpinner, _proSolidSvgIcons.faStar, _proSolidSvgIcons.faStarHalf, _proSolidSvgIcons.faSortAlt, _proSolidSvgIcons.faSortAmountDown, _proSolidSvgIcons.faSortAmountUp, _proSolidSvgIcons.faTachometerAlt, _proSolidSvgIcons.faTimes, _proSolidSvgIcons.faTimesCircle, _proSolidSvgIcons.faUser, _proSolidSvgIcons.faUserMd, _proSolidSvgIcons.faUserCircle, // regular icons
_proRegularSvgIcons.faArchive, _proRegularSvgIcons.faBuilding, _proRegularSvgIcons.faCalendar, _proRegularSvgIcons.faCircle, _proRegularSvgIcons.faEye, _proRegularSvgIcons.faEyeSlash, _proRegularSvgIcons.faExternalLinkSquare, _proRegularSvgIcons.faSquare, _proSolidSvgIcons.faTrash);
/**
 * A hand-picked selection of fontawesome icons for use in the app.
 * Currently all icons are either solid or regular.
 * *We do not have any icons that are pulled from both the solid and regular set simultaneously.*
 * If we end up using both varieties of one icon, i recommend using an 'altStyle' flag that will flip from the default.
 */
// intentionally left as a functional component


var Icon = function Icon(_ref) {
  var className = _ref.className,
      colorTheme = _ref.colorTheme,
      dataTestId = _ref.dataTestId,
      iconName = _ref.iconName,
      inheritColor = _ref.inheritColor,
      size = _ref.size,
      props = _objectWithoutProperties(_ref, ["className", "colorTheme", "dataTestId", "iconName", "inheritColor", "size"]);

  var icon = [];

  if (regularIcons.indexOf(iconName) < 0) {
    icon = ['fas', iconName]; // filled
  } else {
    icon = ['far', iconName]; // regulars
  }

  return /*#__PURE__*/_react.default.createElement(_icon.StyledFontAwesomeIcon, _extends({
    colorTheme: colorTheme,
    "data-test-id": dataTestId,
    icon: icon,
    inheritColor: inheritColor,
    size: size,
    className: className
  }, props));
};

Icon.propTypes = {
  /** Hook for overriding top-level component styles */
  className: _propTypes.PropTypes.string,

  /** Used to pick the color theme to apply to the Icon - One of:
   undefined,
   'default'
   'primary',
   'tertiary',
   'cta',
   'overDark',
   */
  colorTheme: _propTypes.PropTypes.oneOf(_text.textThemes),

  /** Test ID hook */
  dataTestId: _propTypes.PropTypes.string.isRequired,

  /** Reflects string name of fontawesome icon - see 'src/constants/iconNames' for the full list */
  iconName: _propTypes.PropTypes.oneOf(_iconNames.default).isRequired,

  /** inherit colors from parent */
  inheritColor: _propTypes.PropTypes.bool,

  /** Size of Icon */
  size: _propTypes.PropTypes.oneOf([undefined, 'small', 'default', 'large', 'smallLarge', 'mediumLarge', 'extraLarge'])
};
Icon.defaultProps = {
  className: '',
  colorTheme: 'default',
  inheritColor: false,
  size: 'default'
};
var _default = Icon;
exports.default = _default;